import { Component, OnInit, EventEmitter, ViewChild, Output } from '@angular/core';
import {DemoService} from '../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';


// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

// ag- table component

import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';




import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter, PageService, PdfExportService, SortService } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { MysqlService } from '../../../../services/mysql.service';
import { GlobalFunctionsService } from '../../../../services/global-functions.service';

import {Brand} from '../../../../shared/models/brand.model';
import { Job } from '../../../../shared/models/job.model';
import { JobSubject } from '../../../../shared/models/jobSubject.model';
import { SearchSubject } from '../../../../shared/models/searchSubject.model';
import {SearchContact} from '../../../../shared/models/searchContact.model';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';

@Component({
  selector: 'app-report-new-agent-contacts',
  templateUrl: './report-new-agent-contacts.component.html',
  styleUrls: ['./report-new-agent-contacts.component.css']
})
export class ReportNewAgentContactsComponent implements OnInit {
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  valueDatePickerDate: any;
  search_model: SearchContact;
  toolbarOptions: string[];
  initialPage: { pageSize: number; };
  filterOptions: { type: string; };
  formatOptions: { type: string; format: string; };

  @ViewChild('grid') grid: GridComponent;
  brand_types: Object;
  users: Object;
  usersPrimary: Object;
  contact_search: Object;
  contact_search_results: any;
  brand_user_join_results: any[];
  brand_search: Object;
  brand_search_results: any;
  brand_user_join_results_agent: any[];
  brand_search_results_agent: any;
  user_levels: Object;
  user_search: Object;
  user_search_results: any;
  staticTabs: any;
  search_results: any;
  dateFormat: string;
  filter: { params: { format: any; }; };
  pageOptions: { pageSize: number; };

  constructor(
    private http: HttpClient, private router: Router, route: ActivatedRoute,private _demoService: DemoService,
    public datepipe: DatePipe,
    public toastr: HotToastService,
    private _mysqlService: MysqlService, 
    public gfunc: GlobalFunctionsService,
  ) { 

    
       // Set and Access login Session Variables
       this.gfunc.setLoginSessionVars(); // set in a global function file
       this.sessionUserId = this.gfunc.currentUserVAR.user_id;
       this.sessionUsername = this.gfunc.currentUserVAR.username;
       this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
      
            // need to add this as routes does not work globally
            this.all_router_details = this.router.url;
            this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
      
         //   this.toastr.setRootViewContainerRef(vcr);
      // Date picker date format
       //  this.valueDatePickerDate = new Date(this.today);
   
  }


  ngOnInit() {

    
    this.search_model = new SearchContact();
    this.getFormUserLevels();
    this.getBrandBrandTypes();

    // this.mapJobTableLive(); // load the table data
    // this.mapJobTableLiveClients();
    // this.mapJobTableLiveAgents();
    
    this.toolbarOptions = ['ExcelExport', 'Search', 'PdfExport'];
    this.initialPage = { pageSize:5 };
    this.filterOptions = {
      type: 'Menu'
   };
  // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
   this.formatOptions= {type:'date', format:'dd/MM/yyyy' };
   this.dateFormat = 'dd/MM/yyyy hh:mm a';
   this.filter = { params: { format: this.dateFormat } };
  this.pageOptions = { pageSize: 100 }; 

  }














  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
        this.grid.excelExport();
    }
  }
  rowDataBound(args: RowDataBoundEventArgs) {
    const job_status = 'job_status';
    if (args.data[job_status] === 'CLOSED') {
        args.row.className = 'strikethrough';
    }
  }
  
  refreshGrid(){ // refresh the databutton
    this.mapJobTableLive();
    this.grid.refresh();
  }mapJobTableLive() {
    throw new Error('Method not implemented.');
  }
;
  
  
  
  
  getBrandBrandTypes(){
    this._demoService.getBrandBrandTypes().subscribe(
      data => { this.brand_types = data;
       let res = data[0];
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }
  
  getUsers() {
    this._demoService.getUsers().subscribe(
      data => { this.users = data;
        this.usersPrimary = data;
       let res = data[0];
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }
  
  
  brandView(brand_id) {
    this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);
  }
  
  brandEdit(brand_id) {
    this.router.navigate(['/admin/brands/company/edit/' + brand_id + '']);
  }
  
  
  userView(user_id) {
    this.router.navigate(['/admin/brands/users/view/' + user_id + '']);
  }
  
  userEdit(user_id) {
    this.router.navigate(['/admin/brands/users/edit/' + user_id + '']);
  }
  
  
  
  
  // :: Reporting
  getReportContactsSearch(search_model) {
  
    search_model.brand_type_id = null;
    search_model.assigned_agent = null;
    this._demoService.getReportContactsSearch(search_model).subscribe(
      data => { this.contact_search = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.contact_search_results = DataUtil.parse.parseJson(data); 
     //   this.subjects_results = DataUtil.parse.parseJson(data); 
       // console.log("Done loadng USER");
      //  console.log(data);
  
     //  this.items = new DataManager(data as JSON[]).executeLocal(new Query().take(1000));
       this.grid.refresh();
     
       // :: This section allow to hard code predicate filters before loading data in to DataManager
  
        // let predicate: Predicate = new Predicate('subject_name', 'equal', 'Mr Josh Mosh');
        // predicate = predicate.or('subject_id', 'equal', 303);
        // this.items =  new DataManager(this.subjects_urgent).executeLocal(new Query().where(predicate).take(8));
  
      },
      error => {
      console.error('Error Loading !' + error.error);
      console.log(error);
      //return Observable.throw(error);
      }
    ); }
  
  
  
    
  // :: Reporting
  getReportBrandsClientSearch(search_model) {
  this.brand_user_join_results = [];
  search_model.brand_type_id = 2;
  search_model.access_level = 9;
  
  
    // search_model.brand_report_id = null;
    // search_model.assigned_agent = null;
    this._demoService.getReportBrandsSearch(search_model).subscribe(
      data => { this.brand_search = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.brand_search_results = DataUtil.parse.parseJson(data); 
  // get the users as well and join the records together
  this.getReportUsersSearch(search_model);
  
  // now how to join two arrays of objects.
  // maybe pass results in to a new model.
  
  // Count items of brand search to loop through
  let  count_of_brand_items = Object.keys(this.brand_search).length;
  // now loop and push to join model
  for(let i=0;i < count_of_brand_items; i++) {
    let res = this.brand_search[i];
  
      // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
      this.brand_user_join_results.push({
        email_address: res.email,
        first_name: res.name,
        surname: res.surname,
        company_name: res.name,
        created: res.created,
              });
  
  } // end brands loop.
  
  
  
  
  
  
  this.brand_user_join_results = this.brand_user_join_results;
  
       this.grid.refresh();
      },
      error => {
      console.error('Error Loading !' + error.error);
      console.log(error);
      // return Observable.throw(error);
      }
  
  
  
      
    ); }
  
  
  
    
  
    getReportBrandsAgentSearch(search_model) {
      this.brand_user_join_results = [];
      search_model.brand_type_id = 3;
      search_model.access_level = 5;
      this._demoService.getReportBrandsSearch(search_model).subscribe(
        data => { this.brand_search = data;
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
          this.brand_search_results = DataUtil.parse.parseJson(data); 
    // get the users as well and join the records together
    this.getReportUsersSearch(search_model);
    
    // now how to join two arrays of objects.
    // maybe pass results in to a new model.
    
    // Count items of brand search to loop through
    let  count_of_brand_items = Object.keys(this.brand_search).length;
    // now loop and push to join model
    for(let i=0;i < count_of_brand_items; i++) {
      let res = this.brand_search_results[i];
    
        // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
        this.brand_user_join_results.push({
          email_address: res.email,
          first_name: res.name,
          surname: res.surname,
          company_name: res.name,
          created: res.created,
                });
    
    } // end brands loop.
    
    this.brand_user_join_results = this.brand_user_join_results;
    
         this.grid.refresh();
      
          },
          error => {
          console.error('Error Loading !' + error.error);
          console.log(error);
          // return Observable.throw(error);
          }
          );
           
  
            }
      
  
  
  
    getFormUserLevels() {
      this._demoService.getFormUserLevels().subscribe(
         data2 => { this.user_levels = data2;
          console.log(data2);
       },
         err => console.error(err),
         () => console.log('done loading User Levels')
       );
     }
  
  
     getBrandTypes() {
      this._demoService.getBrandBrandTypes().subscribe(
         data => { this.brand_types = data; },
         err => console.error(err),
         // () => console.log('done loading candidate for update')
       );
     }
    
  
    getReportUsersSearch(search_model) {
  
      this._demoService.getReportUsersSearch(search_model).subscribe(
        data => { this.user_search = data;
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
          this.user_search_results = DataUtil.parse.parseJson(data);
  // Count items of users search to loop through
  let  count_of_user_items = Object.keys(this.user_search).length;
  // now loop and push to join model
  for(let i=0;i < count_of_user_items; i++) {
    let res = this.user_search_results[i];
  
  
      // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
      this.brand_user_join_results.push({
        email_address: res.email_address,
        first_name: res.first_name,
        surname: res.surname,
        company_name: res.company_name,
        created_date: res.created_date,
              });
  
  
  } // end users loop.
  
  this.brand_user_join_results =  this.brand_user_join_results;
  this.grid.refresh();
       //  this.agent_grid.refresh();
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
      ); }
  
  
  
  addDays(days : number): Date{
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + days);
  return futureDate;
  }
  
  
  removeDays(days : number): Date{
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() - days);
  return futureDate;
  }
  
  /// TABS
  selectTab(tab_id: number) {
  this.staticTabs.tabs[tab_id].active = true;
  this.brand_user_join_results = null; // refresh the model when a tab is clicked.?
  };
  
  
  
  
  
  
  
  
    // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
    clickHandler(args: ClickEventArgs): void {
      if (args.item.id === 'Click') {
  
      //  this.grid.showSpinner();
  
      //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
     //  console.log(args.data.items);
     
  
  
      let pdfdata;
      const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
      for (let i = 0; i < query.queries.length; i++) {
        if (query.queries[i].fn === 'onPage') {
          query.queries.splice(i, 1);       // remove page query to get all records
          break;
        }
      }
      const fdata = new DataManager({ json: this.brand_user_join_results }).executeQuery(query).then((e: any) => {
        pdfdata = e.result as object[];  // get all filtered records
        const exportProperties = {
          dataSource: pdfdata,
        };
        //console.log(pdfdata.results);
        
       // this.search_results = pdfdata.records; // need this if a grouping is set.
        this.search_results = pdfdata;
        this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
        this.toastr.success( "Press Start To Process Que"); 
       // this.grid.pdfExport(exportProperties);
      }).catch((e) => true);
      }
  
     //  this.grid.hideSpinner();
  
  }
  
  
  exportPDFClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_pdfexport') { // 'Grid_pdfexport' -> Grid component id + _ + toolbar item name
        this.grid.pdfExport();
    }
  }





}
